import * as React from 'react';
import {Component, inject, deps, observer} from '../../lib/component';
import {classes, style} from 'typestyle';
import {center, centerCenter, centerJustified, content, endJustified, horizontal, start, vertical} from 'csstips';
import {ButtonPill} from '../button-pill';
import {em, important, percent, px, rem, url} from 'csx';
import {constantHeaderHeight} from '../../theme/constant';
import {colorSubtle, colorWhite} from '../../theme/color';
import {Loading} from '../loading/loading';
import {mediaMobileOnly} from '../../theme/media';
import {animationSlowPulseOne, animationSlowPulseTwo} from '../../theme/animation';


export type Props = {
  reverse?: boolean;
  onlyAvatarMobile?: boolean;
  className?: string;
  i18n?: {
    signIn: string;
    register: string;
  }
}

@inject(deps) @observer
export default class UserStatusBar extends Component<Props> {
  render() {
    const {className, i18n = UserStatusBar.i18n, onlyAvatarMobile} = this.props;
    const {user, youtubeLoginURL} = this.props.model.auth;
    const {channel, loadingChannels, loading} = this.props.model.user;
    const {handleClickLink} = this.props.controller.ui;

    if (user && (loading || loadingChannels)) {
      return (
        <div className={classes(UserStatusBar.styles.container, className)}>
          <Loading light={true} size={20} className={UserStatusBar.styles.loading} />
        </div>
      )
    }

    const avatar = channel && channel.images && channel.images.length
      ? channel.images[0].url
      : null;

    if (!user) return (
      <div className={classes(UserStatusBar.styles.container, className)}>
        <ButtonPill href={youtubeLoginURL} onClick={this.handleSignIn} className={UserStatusBar.styles.button}>
          <span>{i18n.register}</span>
          <span>{i18n.signIn}</span>
        </ButtonPill>
      </div>
    );

    return (
      <a href="/account" className={classes(UserStatusBar.styles.container, className)} onClick={handleClickLink}>
        <div className={classes(UserStatusBar.styles.avatar, onlyAvatarMobile && UserStatusBar.styles.avatarOnlyMobile)}>
          <div style={{backgroundImage: url(avatar)}}/>
        </div>
        {channel && (
          <div className={classes(UserStatusBar.styles.channel, onlyAvatarMobile && UserStatusBar.styles.channelHiddenMobile)}>
            <div>Channel</div>
            <div>{channel && channel.name}</div>
          </div>
        )}
      </a>
    );
  }

  handleSignIn = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    this.props.controller.analytics.sendMixpanel("User clicks sign up / register")
    this.props.controller.onboarding.openSignUpModal();
  };

  static i18n = {
    signIn: 'Sign in',
    register: 'Register'
  };

  static styles = {
    container: style({
      ...horizontal,
      ...center,
      ...endJustified,
      minWidth: '44px',
    }),
    button: style({
      height: '32px',
      width: '84px',
      position: 'relative',
      color: important(colorWhite.toString()),
      $nest: {
        '& > span': {
          ...centerCenter,
          transition: 'opacity 0.1s ease-in-out',
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
        },
        '& > span:first-child': {
          ...animationSlowPulseOne,
        },
        '& > span:last-child': {
          ...animationSlowPulseTwo,
        }
      }
    }),
    avatar: style(
      {
        ...centerCenter,
        height: constantHeaderHeight,
        width: constantHeaderHeight,
        $nest: {
          '&>div': {
            borderRadius: percent(50),
            backgroundSize: 'cover',
            width: rem(1.75),
            height: rem(1.75),
          }
        }
      }
    ),
    avatarOnlyMobile: style({
      width: '44px !important',
    }),
    loading: style({
      ...centerCenter,
      width: percent(100),
    }),
    channel: style({
      ...vertical,
      ...start,
      ...centerJustified,
      flex: 1,
      lineHeight: em(1),
      position: 'relative',
      fontWeight: 500,
      overflow: 'hidden',
      color: colorWhite.toString(),
      $nest: {
        '& div': {
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          width: percent(100),
        },
        '& div:first-child': {
          fontSize: rem(0.75),
          color: colorWhite.fade(0.75).toString()
        }
      }
    }),
    channelHiddenMobile: style(
      {
        margin: '0 8px',
      },
      mediaMobileOnly({display: 'none'})
    )
  };
}